export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          联系我们
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          投稿 · 合作 · 反馈
        </p>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70 text-center">
            <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-6">
              欢迎通过以下方式与我们联系。我们重视每一位用户的意见，无论是内容建议、合作意向还是问题反馈，都会在第一时间处理回复。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-5 mb-6">
              <div className="flex items-center gap-2 text-foreground-600">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
                <span className="text-sm">contact@jinrikankan.com</span>
              </div>
              <span className="hidden sm:block text-foreground-300">|</span>
              <div className="flex items-center gap-2 text-foreground-600">
                <i className="ri-wechat-line text-primary-500 text-lg"></i>
                <span className="text-sm">今日看料官方</span>
              </div>
            </div>

            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line text-lg"></i>
              查看常见问答
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}